import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import SpareForm from "components/spares/SpareForm";
import { updateSpare } from "graphql/mutations";
import { getSpare } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const SpareUpdateForm = ({ spareId, onSuccess }) => {
  const navigate = useNavigate();
  const [spare, setSpare] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        description,
        status,
        location,
        companyID,
        serviceOrderID,
        equipmentID,
      } = valuesParam;

      setLoading(true);

      await API.graphql({
        query: updateSpare.replaceAll("__typename", ""),
        variables: {
          input: {
            id: spareId,
            name,
            description,
            status,
            location,
            companyID,
            serviceOrderID,
            equipmentID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchSpare(id) {
    try {
      const spareData = await API.graphql(graphqlOperation(getSpare, { id }));
      const spareItem = spareData.data.getSpare;
      if (!spareItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/spares");
        return;
      }
      setSpare({
        ...spareItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchSpare(spareId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spareId]);

  if (!spare) return <Loader />;

  return (
    <div>
      <SpareForm onSubmit={onSubmit} type="update" initialValues={spare} />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Repuesto",
    successUpdated: "Repuesto actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el repuesto",
    },
  },
});

export default SpareUpdateForm;
